import React from "react";

const BookmarkedWorkoutsAndRecipes = () => {
  const bookmarkedWorkouts = [
    { name: "Push Ups", category: "Chest Workout", time: "10min" },
    { name: "Incline Chest Press", category: "Chest Workout", time: "10min" },
    { name: "Squats", category: "Leg Workout", time: "15min" },
    { name: "Deadlifts", category: "Back Workout", time: "20min" },
    { name: "Plank", category: "Core Workout", time: "5min" },
    { name: "Bicep Curls", category: "Arm Workout", time: "12min" },
    { name: "Tricep Dips", category: "Arm Workout", time: "8min" },
    { name: "Lunges", category: "Leg Workout", time: "12min" },
    { name: "Pull Ups", category: "Back Workout", time: "10min" },
    { name: "Leg Press", category: "Leg Workout", time: "15min" },
  ];
  const likedRecipes = [
    { name: "Chicken Biryani" },
    { name: "Oats Salad" },
    { name: "Paneer Tikka" },
    { name: "Grilled Salmon" },
    { name: "Veg Pulao" },
    { name: "Avocado Toast" },
    { name: "Chicken Caesar Salad" },
    { name: "Vegetable Stir Fry" },
    { name: "Egg Salad" },
    { name: "Chocolate Protein Shake" },
  ];

  return (
    <div className="row d-flex py-3">
    <div className="col-lg-6 mb-4">
      <h6 className="text-left fw-bold">Bookmarked Workouts</h6>
      <div className="mb-4">
        <div
          className="table-responsive"
          style={{ maxHeight: "300px", borderRadius: "10px" }}
        >
          <table className="table table-bordered mb-0 rounded-3 ">
            <thead className="table-primary" style={{ position: "sticky", top: "0", zIndex: "1" }}>
              <tr>
                <th>Workout Name</th>
                <th>Category</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {bookmarkedWorkouts.map((workout, index) => (
                <tr key={index}>
                  <td className="ps-3">{workout.name}</td>
                  <td className="ps-3">{workout.category}</td>
                  <td className="ps-3">{workout.time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  
    <div className="col-lg-6 mb-4">
      <h6 className="text-left fw-bold">Liked Recipes</h6>
      <div className="mb-4">
        <div
          className="table-responsive"
          style={{ maxHeight: "300px", borderRadius: "10px" }}
        >
          <table className="table table-bordered mb-0 rounded-3">
            <thead className="bg-success text-white table-primary" style={{ position: "sticky", top: "0", zIndex: "1" }}>
              <tr>
                <th>Recipe Name</th>
              </tr>
            </thead>
            <tbody>
              {likedRecipes.map((recipe, index) => (
                <tr key={index}>
                  <td className="ps-3">{recipe.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  
  );
};

export default BookmarkedWorkoutsAndRecipes;
